import {HttpService} from "../http/HttpService";
import {AbstractAdminEntityService} from "./AbstractAdminEntityService";
import {Contest, ContestListResponse} from "../http/protocol";


export class ContestsService  extends AbstractAdminEntityService<Contest, ContestListResponse>  {

    constructor(http : HttpService) {
        super("/contests", http)
    }

}